module.exports = require("rxjs/observable/throw");